module.exports = __webpack_public_path__ + "img/TripleBigWheel6x4x3x2xVIP_EGM.59971fc8.png";